module.exports = __webpack_public_path__ + "static/media/image.ebaabcbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FBGroup/image.png
// module id = 83
// module chunks = 0